__turbopack_context__.v({
  "bottomInfo": "FavoriteMoments-module-scss-module__fDG3GW__bottomInfo",
  "bottomInfo_box": "FavoriteMoments-module-scss-module__fDG3GW__bottomInfo_box",
  "bottomInfo_description": "FavoriteMoments-module-scss-module__fDG3GW__bottomInfo_description",
  "bottomInfo_piece": "FavoriteMoments-module-scss-module__fDG3GW__bottomInfo_piece",
  "bottomInfo_time": "FavoriteMoments-module-scss-module__fDG3GW__bottomInfo_time",
  "description": "FavoriteMoments-module-scss-module__fDG3GW__description",
  "description_box": "FavoriteMoments-module-scss-module__fDG3GW__description_box",
  "link": "FavoriteMoments-module-scss-module__fDG3GW__link",
  "mapBox": "FavoriteMoments-module-scss-module__fDG3GW__mapBox",
  "title": "FavoriteMoments-module-scss-module__fDG3GW__title",
  "title_box": "FavoriteMoments-module-scss-module__fDG3GW__title_box",
  "wrapper": "FavoriteMoments-module-scss-module__fDG3GW__wrapper",
});
